import { ReactComponent as ChartNotSelectedIcon } from './chart_not_selected.svg';

export default ChartNotSelectedIcon;
